module.exports = __webpack_public_path__ + "img/Help Desk _.36405c1f.svg";